// extracted by mini-css-extract-plugin
module.exports = {"product":"styles_product__YTJx7"};